<template>
  <div class="asc-feature-flags-template">
    <asc-feature-flags-wrapper></asc-feature-flags-wrapper>
  </div>
</template>

<script>
import AscFeatureFlagsWrapper from '@/components/organisms/AscFeatureFlagsWrapper'

export default {
  name: 'AscFeatureFlagsTemplate',

  components: {
    AscFeatureFlagsWrapper,
  },
}
</script>
